import React, { useState, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { FilterSelect } from "@td/ui";
import { translate } from "@td/shared_utils";
import { useMemberSearch } from "../hooks";
import { debounce } from "lodash";

const LOAD_OPTIONS_DEBOUNCE_DELAY = 500;

const filterDropdownProps = {
  "data-testid": "member-filter",
};

const MemberFilter = React.memo(({ value, onChange }) => {
  const [inputValue, setInputValue] = useState("");
  const { findMember } = useMemberSearch();

  const handleInputChange = useCallback((inputValue) => {
    const newValue = inputValue.replace(/\D/g, "");
    setInputValue(newValue);

    return newValue;
  }, [setInputValue]);

  const loadOptions = useCallback(async (inputValue, callback) => {
    const memberId = parseInt(inputValue);
    const member = memberId && memberId > 0 ? await findMember(memberId) : null;

    if (member) {
      const { id, name } = member;

      callback([{
        value: id,
        label: translate(null, "care_team_tasks.filters.fields.member.option", "label", { name, id }),
      }]);
    } else {
      callback([]);
    }
  }, [findMember]);

  const debouncedLoadOptions = useMemo(() => {
    return debounce((inputValue, callback) => {
      loadOptions(inputValue, callback);
    }, LOAD_OPTIONS_DEBOUNCE_DELAY)
  }, [loadOptions]);

  return (
    <FilterSelect
      async
      isMulti
      cacheOptions
      defaultOptions={value}
      loadOptions={debouncedLoadOptions}
      value={value}
      onChange={onChange}
      inputValue={inputValue}
      onInputChange={handleInputChange}
      label={translate(null, "care_team_tasks.filters.fields.member", "label")}
      placeholder={translate(null, "care_team_tasks.filters.fields.member", "placeholder")}
      filterDropdownProps={filterDropdownProps}
    />
  );
});

MemberFilter.propTypes = {
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

MemberFilter.displayName = "MemberFilter";

export default MemberFilter;
